import React, { useState } from 'react';
import { Ic, ICONS } from '../data/icons';
import { Card, CardHeader, Badge, toast, FormField, Input, Select } from '../components/shared';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000';

async function generateKeysRequest() {
  const token = localStorage.getItem('mdm_token');
  const res = await fetch(`${API_BASE}/api/enrollment/generate-keys`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.message || 'Anahtar oluşturulamadı');
  }
  return await res.json();
}

async function generatePublicKeyRequest() {
  const token = localStorage.getItem('mdm_token');
  const res = await fetch(`${API_BASE}/api/enrollment/generate-public-key`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.message || 'Public key oluşturulamadı');
  }
  return await res.json();
}

const SECTIONS = [
  { key:'profile',   icon:'users',    label:'Profil' },
  { key:'security',  icon:'lock',     label:'Güvenlik' },
  { key:'notif',     icon:'bell',     label:'Bildirimler' },
  { key:'system',    icon:'server',   label:'Sistem' },
  { key:'keys',      icon:'key',      label:'Anahtar Yönetimi' },
  { key:'theme',     icon:'sun',      label:'Görünüm' },
];

export default function Settings({ C, theme, setTheme }) {
  const [section, setSection] = useState('profile');
  const [saved, setSaved] = useState({});
  const [profile, setProfile] = useState({ name:'Admin Kullanıcı', email:'admin@corpmdm.com', phone:'+90 555 000 0000', dept:'Mühendislik', role:'Süper Admin' });
  const [pw, setPw] = useState({ current:'', next:'', confirm:'' });
  const [notif, setNotif] = useState({ email:true, breach:true, offline:true, update:false, weekly:true });
  const [sys, setSys] = useState({ timeout:30, language:'tr', logRetention:90 });
  const [keyLoading, setKeyLoading] = useState(false);
  const [publicKeyUrl, setPublicKeyUrl] = useState(null);
  const [abmTokenLoading, setAbmTokenLoading] = useState(false);
  const [abmTokenStatus, setAbmTokenStatus] = useState(null);

  const save = (key) => {
    setSaved(s => ({ ...s, [key]: true }));
    toast.success('Ayarlar kaydedildi');
    setTimeout(() => setSaved(s => ({ ...s, [key]: false })), 2000);
  };

  const Toggle = ({ val, onChange, label, desc }) => (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:16, padding:'14px 0', borderBottom:`1px solid ${C.border}` }}>
      <div>
        <div style={{ fontSize:13.5, fontWeight:600, color:C.text }}>{label}</div>
        {desc && <div style={{ fontSize:12, color:C.textFaint, marginTop:2 }}>{desc}</div>}
      </div>
      <button onClick={() => onChange(!val)} style={{ width:42, height:24, borderRadius:12, border:'none', cursor:'pointer', background:val ? C.accent : C.border2, position:'relative', transition:'background 0.2s', flexShrink:0 }}>
        <div style={{ width:18, height:18, borderRadius:'50%', background:'#fff', position:'absolute', top:3, left:val?21:3, transition:'left 0.2s', boxShadow:'0 1px 4px rgba(0,0,0,0.3)' }} />
      </button>
    </div>
  );

  const handleAbmTokenUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setAbmTokenLoading(true);
    setAbmTokenStatus(null);
    try {
      const formData = new FormData();
      formData.append('abmToken', file);
      const token = localStorage.getItem('mdm_token');
      const res = await fetch(`${API_BASE}/api/enrollment/upload-abm-token`, {
        method: 'POST',
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: formData,
      });
      if (!res.ok) throw new Error('Yükleme başarısız');
      setAbmTokenStatus('success');
      toast.success('ABM token başarıyla yüklendi!');
    } catch (err) {
      setAbmTokenStatus('error');
      toast.error('ABM token yüklenemedi!');
    } finally {
      setAbmTokenLoading(false);
    }
  };

  const renderSection = () => {
    if (section === 'profile') return (
      <div style={{ display:'flex', flexDirection:'column', gap:0 }}>
        <CardHeader C={C} title='Profil Bilgileri' action={
          <button onClick={() => save('profile')} style={{ padding:'6px 14px', borderRadius:8, border:'none', background:C.accent, color:'#fff', fontSize:12, fontWeight:700, cursor:'pointer' }}>
            {saved.profile ? '✓ Kaydedildi' : 'Kaydet'}
          </button>
        } />
        <div style={{ padding:20, display:'flex', flexDirection:'column', gap:16 }}>
          <div style={{ display:'flex', alignItems:'center', gap:16, padding:'16px 20px', background:C.surface2, borderRadius:12, marginBottom:4 }}>
            <div style={{ width:64, height:64, borderRadius:'50%', background:'linear-gradient(135deg,#3b82f6,#8b5cf6)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:22, fontWeight:800, color:'#fff', flexShrink:0 }}>
              {profile.name.split(' ').map(s=>s[0]).join('').slice(0,2)}
            </div>
            <div>
              <div style={{ fontSize:16, fontWeight:800, color:C.text }}>{profile.name}</div>
              <div style={{ fontSize:12, color:C.textFaint, marginTop:2 }}>{profile.email}</div>
              <div style={{ marginTop:6 }}><Badge color={C.accent}>{profile.role}</Badge></div>
            </div>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
            {[['name','Ad Soyad'],['email','E-posta'],['phone','Telefon'],['dept','Departman']].map(([k,l]) => (
              <FormField key={k} label={l} C={C}>
                <Input C={C} value={profile[k]} onChange={e => setProfile(p => ({...p, [k]:e.target.value}))} placeholder={l} />
              </FormField>
            ))}
          </div>
        </div>
      </div>
    );

    if (section === 'security') return (
      <div>
        <CardHeader C={C} title='Güvenlik Ayarları' />
        <div style={{ padding:20, display:'flex', flexDirection:'column', gap:20 }}>
          <div>
            <div style={{ fontSize:14, fontWeight:700, color:C.text, marginBottom:14 }}>Şifre Değiştir</div>
            <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
              {[['current','Mevcut Şifre'],['next','Yeni Şifre'],['confirm','Yeni Şifre Tekrar']].map(([k,l]) => (
                <FormField key={k} label={l} C={C}>
                  <Input C={C} type='password' value={pw[k]} onChange={e => setPw(p=>({...p,[k]:e.target.value}))} placeholder='••••••••' />
                </FormField>
              ))}
              <button onClick={() => { if(pw.next !== pw.confirm) return toast.error('Şifreler eşleşmiyor'); toast.success('Şifre güncellendi'); setPw({current:'',next:'',confirm:''}); }}
                style={{ alignSelf:'flex-start', padding:'9px 20px', borderRadius:9, border:'none', background:C.accent, color:'#fff', fontSize:13, fontWeight:700, cursor:'pointer' }}>
                Şifreyi Güncelle
              </button>
            </div>
          </div>
          <div style={{ borderTop:`1px solid ${C.border}`, paddingTop:20 }}>
            <div style={{ fontSize:14, fontWeight:700, color:C.text, marginBottom:14 }}>İki Faktörlü Doğrulama</div>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'14px 16px', background:C.surface2, borderRadius:12 }}>
              <div>
                <div style={{ fontSize:13, fontWeight:600, color:C.text }}>Authenticator Uygulaması</div>
                <div style={{ fontSize:12, color:C.textFaint, marginTop:2 }}>Google Authenticator veya benzeri</div>
              </div>
              <button style={{ padding:'7px 14px', borderRadius:8, border:`1px solid ${C.border}`, background:'transparent', color:C.textSub, fontSize:12, fontWeight:600, cursor:'pointer' }}>Etkinleştir</button>
            </div>
          </div>
          <div style={{ borderTop:`1px solid ${C.border}`, paddingTop:20 }}>
            <div style={{ fontSize:14, fontWeight:700, color:C.text, marginBottom:14 }}>Aktif Oturumlar</div>
            {[{device:'MacBook Pro · Chrome',location:'İstanbul, TR',time:'Şu an aktif',active:true},{device:'iPhone 15 Pro · Safari',location:'İstanbul, TR',time:'2 saat önce',active:false}].map((s,i) => (
              <div key={i} style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'12px 16px', background:C.surface2, borderRadius:10, marginBottom:8 }}>
                <div>
                  <div style={{ fontSize:13, fontWeight:600, color:C.text }}>{s.device}</div>
                  <div style={{ fontSize:11, color:C.textFaint, marginTop:2 }}>{s.location} · {s.time}</div>
                </div>
                {s.active ? <Badge color={C.green}>Aktif</Badge> : <button style={{ padding:'4px 10px', borderRadius:7, border:`1px solid ${C.red}44`, background:C.redBg, color:C.red, fontSize:11, fontWeight:600, cursor:'pointer' }}>Sonlandır</button>}
              </div>
            ))}
          </div>
        </div>
      </div>
    );

    if (section === 'notif') return (
      <div>
        <CardHeader C={C} title='Bildirim Tercihleri' action={
          <button onClick={() => save('notif')} style={{ padding:'6px 14px', borderRadius:8, border:'none', background:C.accent, color:'#fff', fontSize:12, fontWeight:700, cursor:'pointer' }}>
            {saved.notif ? '✓ Kaydedildi' : 'Kaydet'}
          </button>
        } />
        <div style={{ padding:'0 20px 20px' }}>
          <Toggle val={notif.email}  onChange={v=>setNotif(n=>({...n,email:v}))}   label='E-posta Bildirimleri'   desc='Önemli olaylar için e-posta gönder' />
          <Toggle val={notif.breach} onChange={v=>setNotif(n=>({...n,breach:v}))}  label='Güvenlik İhlalleri'     desc='Cihaz ihlali tespit edildiğinde uyar' />
          <Toggle val={notif.offline} onChange={v=>setNotif(n=>({...n,offline:v}))} label='Çevrimdışı Cihazlar'   desc='48 saattir çevrimdışı olan cihazlar' />
          <Toggle val={notif.update} onChange={v=>setNotif(n=>({...n,update:v}))}  label='Güncelleme Bildirimleri' desc='Yeni sistem güncellemeleri için' />
          <Toggle val={notif.weekly} onChange={v=>setNotif(n=>({...n,weekly:v}))}  label='Haftalık Özet Raporu'   desc='Her Pazartesi özet e-posta gönder' />
        </div>
      </div>
    );

    if (section === 'system') return (
      <div>
        <CardHeader C={C} title='Sistem Ayarları' action={
          <button onClick={() => save('system')} style={{ padding:'6px 14px', borderRadius:8, border:'none', background:C.accent, color:'#fff', fontSize:12, fontWeight:700, cursor:'pointer' }}>
            {saved.system ? '✓ Kaydedildi' : 'Kaydet'}
          </button>
        } />
        <div style={{ padding:20, display:'flex', flexDirection:'column', gap:16 }}>
          <FormField label='Oturum Zaman Aşımı (dakika)' C={C}>
            <Select C={C} value={sys.timeout} onChange={e => setSys(s=>({...s,timeout:Number(e.target.value)}))}>
              {[15,30,60,120].map(v => <option key={v} value={v}>{v} dakika</option>)}
            </Select>
          </FormField>
          <FormField label='Arayüz Dili' C={C}>
            <Select C={C} value={sys.language} onChange={e => setSys(s=>({...s,language:e.target.value}))}>
              <option value='tr'>Türkçe</option>
              <option value='en'>English</option>
            </Select>
          </FormField>
          <FormField label='Log Saklama Süresi (gün)' C={C}>
            <Select C={C} value={sys.logRetention} onChange={e => setSys(s=>({...s,logRetention:Number(e.target.value)}))}>
              {[30,60,90,180,365].map(v => <option key={v} value={v}>{v} gün</option>)}
            </Select>
          </FormField>
          <div style={{ borderTop:`1px solid ${C.border}`, paddingTop:16 }}>
            <div style={{ fontSize:13, fontWeight:700, color:C.text, marginBottom:12 }}>Tehlikeli Bölge</div>
            <button onClick={() => toast.error('Bu işlem demo modunda devre dışı')} style={{ padding:'9px 18px', borderRadius:9, border:`1px solid ${C.red}44`, background:C.redBg, color:C.red, fontSize:12.5, fontWeight:700, cursor:'pointer' }}>
              Tüm Verileri Sıfırla
            </button>
          </div>
        </div>
      </div>
    );

    // macOS and Windows enrollment sections removed (now unified on MDM Enrollment page)
    // (Sidebar entries also removed)

    if (section === 'keys') return (
      <div>
        <CardHeader C={C} title='Anahtar Yönetimi' />
        <div style={{ padding:20, display:'flex', flexDirection:'column', gap:20 }}>
          <div>
            <div style={{ fontSize:14, fontWeight:700, color:C.text, marginBottom:14 }}>ABM Public Key (.pem) Oluştur</div>
            <div style={{ padding:'16px', background:C.surface2, borderRadius:12, marginBottom:16 }}>
              <div style={{ fontSize:13, color:C.textSub, marginBottom:12, lineHeight:1.6 }}>
                Apple Business Manager (ABM) entegrasyonu için bir <b>public key (.pem)</b> oluşturun. 
                Bu dosyayı ABM portalına yükleyerek sisteminizi Apple ile güvenli şekilde entegre edebilirsiniz.
              </div>
              <div style={{ fontSize:12, color:C.textFaint, padding:'10px 12px', background:C.bg, borderRadius:8, border:`1px solid ${C.border}` }}>
                <strong>Adımlar:</strong>
                <ol style={{ margin:'8px 0 0 0', paddingLeft:18 }}>
                  <li style={{ marginBottom:4 }}>Aşağıdaki butona tıklayarak yeni bir public key oluşturun</li>
                  <li style={{ marginBottom:4 }}>Oluşturulan <b>public.pem</b> dosyasını indirin</li>
                  <li style={{ marginBottom:4 }}>ABM portalına giriş yapın ve "Açık Anahtarı Yükle" bölümüne gidin</li>
                  <li>İndirdiğiniz <b>public.pem</b> dosyasını ABM'ye yükleyin</li>
                </ol>
              </div>
            </div>
            <button 
              onClick={async () => {
                setKeyLoading(true);
                try {
                  const response = await generatePublicKeyRequest();
                  setPublicKeyUrl(`${API_BASE}${response.publicKeyPath}`);
                  toast.success('Public key başarıyla oluşturuldu!');
                } catch (error) {
                  console.error('Public key oluşturma hatası:', error);
                  toast.error('Public key oluşturulurken bir hata oluştu.');
                } finally {
                  setKeyLoading(false);
                }
              }}
              disabled={keyLoading}
              style={{ padding:'10px 20px', borderRadius:9, border:'none', background:C.accent, color:'#fff', fontSize:13, fontWeight:700, cursor:keyLoading?'not-allowed':'pointer', opacity:keyLoading?0.6:1 }}
            >
              {keyLoading ? '⏳ Oluşturuluyor...' : '🔑 Public Key Oluştur'}
            </button>
            {publicKeyUrl && (
              <div style={{ marginTop:16, padding:'16px', background:C.accentBg, border:`1px solid ${C.accentBorder}`, borderRadius:10 }}>
                <div style={{ fontSize:13, fontWeight:600, color:C.accent, marginBottom:10 }}>✓ Public key başarıyla oluşturuldu!</div>
                <div style={{ fontSize:12, color:C.textSub, marginBottom:12 }}>Özel anahtar güvenli bir şekilde sunucuda saklandı. Public key dosyasını indirmek için:</div>
                <a 
                  href={publicKeyUrl} 
                  download="public.pem"
                  style={{ display:'inline-flex', alignItems:'center', gap:8, padding:'8px 16px', borderRadius:8, background:C.accent, color:'#fff', fontSize:12, fontWeight:600, textDecoration:'none', cursor:'pointer' }}
                >
                  <Ic d={ICONS.download} size={14} />
                  Public Key İndir
                </a>
              </div>
            )}
          </div>
          <div>
            <div style={{ fontSize:14, fontWeight:700, color:C.text, marginBottom:14 }}>ABM Token (.p7m) Yükle</div>
            <div style={{ padding:'16px', background:C.surface2, borderRadius:12, marginBottom:16 }}>
              <div style={{ fontSize:13, color:C.textSub, marginBottom:12, lineHeight:1.6 }}>
                ABM portalından indirdiğiniz <b>.p7m</b> dosyasını buradan sisteme yükleyin.
              </div>
              <input type="file" accept=".p7m" onChange={handleAbmTokenUpload} disabled={abmTokenLoading} style={{ marginTop:8 }} />
              {abmTokenStatus === 'success' && <div style={{ color: C.green, marginTop: 8 }}>✓ Dosya başarıyla yüklendi.</div>}
              {abmTokenStatus === 'error' && <div style={{ color: C.red, marginTop: 8 }}>✗ Dosya yüklenemedi.</div>}
            </div>
          </div>
          <div style={{ borderTop:`1px solid ${C.border}`, paddingTop:20 }}>
            <div style={{ fontSize:14, fontWeight:700, color:C.text, marginBottom:14 }}>VPP Token Durumu</div>
            <div style={{ padding:'14px 16px', background:C.surface2, borderRadius:10 }}>
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                <div>
                  <div style={{ fontSize:13, fontWeight:600, color:C.text }}>Volume Purchase Program Token</div>
                  <div style={{ fontSize:12, color:C.textFaint, marginTop:2 }}>downloadtoken.p7m</div>
                </div>
                <Badge color={C.green}>Yüklü</Badge>
              </div>
            </div>
          </div>
        </div>
      </div>
    );

    if (section === 'theme') return (
      <div>
        <CardHeader C={C} title='Görünüm Ayarları' />
        <div style={{ padding:20, display:'flex', flexDirection:'column', gap:20 }}>
          <div>
            <div style={{ fontSize:13, fontWeight:700, color:C.text, marginBottom:12 }}>Tema</div>
            <div style={{ display:'flex', gap:12 }}>
              {['dark','light'].map(t => (
                <button key={t} onClick={() => { setTheme(t); toast.success(`${t==='dark'?'Koyu':'Açık'} tema aktif`); }}
                  style={{ flex:1, padding:'14px', borderRadius:12, border:`2px solid ${theme===t ? C.accent : C.border}`, background:t==='dark'?'#080c14':'#eef2f8', cursor:'pointer', transition:'all 0.2s' }}>
                  <div style={{ fontSize:14, fontWeight:700, color:t==='dark'?'#f1f5f9':'#0f172a', marginBottom:4 }}>{t==='dark'?'🌙 Koyu':'☀️ Açık'}</div>
                  <div style={{ fontSize:11, color:t==='dark'?'#94a3b8':'#64748b' }}>{ t===theme ? 'Aktif' : 'Seç' }</div>
                </button>
              ))}
            </div>
          </div>
          <div>
            <div style={{ fontSize:13, fontWeight:700, color:C.text, marginBottom:12 }}>Kenar Çubuğu</div>
            <div style={{ padding:'12px 16px', background:C.surface2, borderRadius:10, fontSize:13, color:C.textSub }}>
              Kenar çubuğu genişliği ve pozisyonu sol üstteki ok butonu ile ayarlanabilir.
            </div>
          </div>
          <div>
            <div style={{ fontSize:13, fontWeight:700, color:C.text, marginBottom:12 }}>Yazı Tipi Boyutu</div>
            <div style={{ display:'flex', gap:8 }}>
              {['Küçük','Normal','Büyük'].map((s,i) => (
                <button key={s} style={{ flex:1, padding:'9px', borderRadius:9, border:`1px solid ${i===1 ? C.accentBorder : C.border}`, background:i===1 ? C.accentBg : 'transparent', color:i===1 ? C.accent : C.textSub, fontSize:12, fontWeight:i===1?700:400, cursor:'pointer' }}>{s}</button>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div style={{ display:'flex', gap:16 }}>
      {/* Sidebar */}
      <div style={{ width:200, flexShrink:0, display:'flex', flexDirection:'column', gap:4 }}>
        {SECTIONS.map(s => (
          <button key={s.key} onClick={() => setSection(s.key)} style={{ display:'flex', alignItems:'center', gap:10, padding:'10px 14px', borderRadius:9, border:`1px solid ${section===s.key ? C.accentBorder : 'transparent'}`, background:section===s.key ? C.accentBg : 'transparent', color:section===s.key ? C.accent : C.textSub, fontSize:13, fontWeight:section===s.key?700:400, cursor:'pointer', textAlign:'left', transition:'all 0.15s' }}>
            <Ic d={ICONS[s.icon]} size={15} />
            {s.label}
          </button>
        ))}
      </div>
      {/* Content */}
      <div style={{ flex:1, minWidth:0 }}>
        <Card C={C}>{renderSection()}</Card>
      </div>
    </div>
  );
}
